import axios from 'axios';
import { getApigatewayHost, json2formdata } from '../../../utils';
import getToken from '../../../utils/getToken';

/**
 * 图片上传
 */
export default file =>
    new Promise(async (resolve, reject) => {
        const params = {
            item_name: 'v',
            file_name: file.name,
            file_type: 'file',
            file: file,
        };
        let token
        try {
            token = await getToken(); 
        } catch (error) {
            token = await getToken(true)
        }
        console.log(token,'token123')
        axios
            .post(`${getApigatewayHost()}/base/v1/upload/upload`, json2formdata(params), {
                headers: {
                    'Authentication': `Basic ${token}`
                }
            })
            .then((res: any) => {
                const { status, info, result } = res.data;
                if (!status) {
                    resolve(result);
                } else {
                    reject(info);
                }
            })
            .catch(e => {
                reject(e.toString());
            });
    });
